<script>
  import {
    VTabs
  } from 'vuetify/lib'
  export default {
    name: 'wh-tabs',
    extends: VTabs
  };
</script>